let apiURL = ''
let apiURLNew = ''
let setApiClient = function (role, Params) {
  if (role === 'admin' ) {
    Params.apiclient = 'reservation_admin'
    if (process.env.NODE_ENV === 'development') {
      Params.apikey = 'reservation_admin123'
    } else if (process.env.NODE_ENV === 'production') {
      Params.apikey = 'reservation_admin1805'
    }
  }
  else if (role === 'merchant') {
    Params.apiclient = 'reservation_merchant'
    if (process.env.NODE_ENV === 'development') {
      Params.apikey = 'reservation_merchant1805'
    } else if (process.env.NODE_ENV === 'production') {
      Params.apikey = 'reservation_merchant1805'
    }
  }
  else if (role === 'merchant' || role === 'spalogin') {
    Params.apiclient = 'reservation_merchant'
    if (process.env.NODE_ENV === 'development') {
      Params.apikey = 'reservation_merchant1805'
    } else if (process.env.NODE_ENV === 'production') {
      Params.apikey = 'reservation_merchant1805'
    }
  }
  else if (role === 'merchant_empty') {
    Params.apiclient = 'reservation_merchant'
    if (process.env.NODE_ENV === 'development') {
      Params.apikey = 'reservation_merchant1805'
    } else if (process.env.NODE_ENV === 'production') {
      Params.apikey = 'reservation_merchant1805'
    }
  }
  else if (role === 'user') {
    Params.apiclient = 'reservation_user'
    if (process.env.NODE_ENV === 'development') {
      Params.apikey = 'reservation_user123'
    } else if (process.env.NODE_ENV === 'production') {
      Params.apikey = 'reservation_user1805'
    }
  }
  else if (role === 'nineder') {
    Params.apiclient = 'nineder_api'
    if (process.env.NODE_ENV === 'development') {
      Params.apikey = 'nineder_api123'
      // Params.apikey = 'nineder_api1805'
    } else if (process.env.NODE_ENV === 'production') {
      Params.apikey = 'nineder_api1805'
    }
  }
  else if (role === 'trial') {
    Params.apiclient = 'imgsrv_api'
    if (process.env.NODE_ENV === 'development') {
      Params.apikey = 'imgsrv_api123'
      // Params.apikey = 'nineder_api1805'
    } else if (process.env.NODE_ENV === 'production') {
      Params.apikey = 'imgsrv_api1903'
    }
  }
}
// TODO記得環境要改回來
if (process.env.NODE_ENV === 'development') {
  apiURL = 'http://localhost:8000/reservation_api/postapi/'
  //另一個module的api
  apiURLNew = 'http://localhost:8000/img_service/postapi/'
  // apiURL = 'http://spaapi.shopping99.com/reservation_api/postapi/'
} else if (process.env.NODE_ENV === 'production') {
  apiURL = 'https://spaapi.shopping99.com/reservation_api/postapi/'
  apiURLNew = 'https://spaapi.shopping99.com/img_service/postapi/'
}
let apiTargetMap = {
  'default':{
    'dev':"https://spaapi.shopping99.com/reservation_api/postapi/",
    'prod':"https://spaapi.shopping99.com/reservation_api/postapi/"
  },
  'rest':{
    'dev':"http://localhost:8000/reservation_api/restful/",
    'prod':"https://spaapi.shopping99.com/reservation_api/restful/"
  },
  'trial':{
    'dev':"http://localhost:8000/img_service/postapi/",
    'prod':"https://spaapi.shopping99.com/img_service/postapi/"
  },
  'jsp':{
    'dev':"http://app.shopping99.com/",
    "prod":"http://app.shopping99.com/"
  },
  'test':{
    'dev':"http://localhost:8000/reservation_api/",
    "prod":"http://localhost:8000/reservation_api/"
  }
}

export { apiURL, setApiClient, apiURLNew, apiTargetMap }
